/* eslint-disable import/no-mutable-exports */
/* eslint-disable no-extra-boolean-cast */
import axios from 'axios';

const BASE_URL = {
  dev: 'http://172.16.12.66:3001',
  prod: 'https://back.store.ufe.mn',
};

const BASE_API_URL = {
  dev: 'http://172.16.12.66:3001/api',
  prod: 'https://back.store.ufe.mn/api',
};

export const API_URL = BASE_URL.prod;
export const EXPORT_API_URL = BASE_API_URL.prod;

let customAxios = axios.create({
  baseURL: EXPORT_API_URL,
});

const handleLocalStorage = () => {
  window.dispatchEvent(new Event('storage'));
};

window.addEventListener('storage', () => {
  const accessToken = localStorage.getItem('token');
  customAxios = axios.create({
    baseURL: EXPORT_API_URL,
    headers: { Authorization: `Bearer ${accessToken}` },
  });
});
handleLocalStorage();

customAxios.interceptors.response.use(null, (error) => {
  if (error.config && error.response && error.response.status === 401) {
    const token = localStorage.getItem('token');
    error.config.headers.common = { Authorization: `Bearer ${token}` };
    return axios.request(error.config);
  }

  return Promise.reject(error);
});

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default customAxios;
